// Function to highlight a marker
export const highlightMarker = (
  map: google.maps.Map,
  marker: google.maps.Marker
): void => {
  if (!marker || !map) {
    return;
  }

  const position = marker.getPosition();
  const currentZoom = map.getZoom();
  const newZoom = 10;

  if (!position) {
    return;
  }

  // Prevent zooming out when a marker on a higher zoom level is clicked
  if (currentZoom < newZoom) {
    map.setZoom(newZoom);
  }

  // Move to marker's position and zoom in
  map.panTo(position);
};
